
import React, { Component } from 'react';
import Pause from 'components/Pause';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import introAfter from '../../assets/sounds/no/intros/NonWord-Intro-AFTER-trail-exercises.mp3';

class PauseAfterTrial extends Component {
  render() {
    return (
      <div className="PauseAfterTrial">
        <p>
          <AudioPlayer autoplay inline src={introAfter} />
          {strings.nonword_intro_after_trial_1 ||
            'Nå har du skjønt hva du skal gjøre, så nå kan vi starte på de ordentlige oppgavene.'}
          <br />
          {strings.nonword_intro_after_trial_2 ||
            'Men nå får du bare høre ordene én gang, så hør godt etter hva jeg sier …'}
          <br />
          {strings.nonword_intro_after_trial_3 ||
            'Trykk på startknappen når du er klar.'}
        </p>

       
        <Pause {...this.props} />
      </div>
    );
  }
}

export default PauseAfterTrial;
